import type { ElibooApp } from '@eliboo/api-models';

import { Injectable, signal } from '@angular/core';
import { map, of, tap } from 'rxjs';

import { useApiChannelOperatorConfig } from '../api/channel/use-channel-operator-config.api';

@Injectable()
export class InvoiceService {
  apis = {
    channelOperatorConfig: useApiChannelOperatorConfig().api,
  }

  /** 渠道配置 */
  channelOperatorConfig = signal<ElibooApp.ChannelOperatorConfigDTO>({});
  /** 获取渠道配置 */
  getChannelOperatorConfig(businessLicenseInfoSheetId: string) {
    // throw new Error('营业执照不存在');
    return this.apis.channelOperatorConfig({ businessLicenseInfoSheetId }).pipe(
      map(res => res.data || {}),
      tap(res => {
        this.channelOperatorConfig.set(res);
      })
    );
  }
}
